/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type ServiceDetailsPageDataQueryVariables = Types.Exact<{
    mpvId: Types.Scalars['String'];
}>;

export type ServiceDetailsPageDataQuery = {
    __typename: 'Query';
    expertServices: Array<{
        __typename: 'ExpertService';
        printProduct: Types.Maybe<{
            __typename: 'PrintProduct';
            name: string;
            retired: boolean;
            mpvId: string;
        }>;
        serviceProduct: {
            __typename: 'ServiceProduct';
            name: string;
            mpvId: string;
            productKey: string;
            pimMerchantVersion: number;
        };
        price: {
            __typename: 'ExpertServicePrice';
            currency: string;
            listPrice: { __typename: 'PriceDetail'; taxed: number; untaxed: number };
        };
    }>;
    serviceDetailPage: {
        __typename: 'ContentModel';
        contentful_id: string;
        name: string;
        description: string;
        merchandisingProductView: {
            __typename: 'MerchandisingProductView';
            contentful_id: string;
            mpvId: string;
        };
        inclusions: Array<{
            __typename: 'Inclusion';
            contentful_id: string;
            contentfulName: string;
            description: string;
            descriptionHtml: string;
        }>;
        heroImages: Array<{
            __typename: 'MultimediaComponent';
            altTextOverride: string;
            contentful_id: string;
            cloudinaryImage: {
                __typename: 'CloudinaryImage';
                cloudinaryUrl: string;
                mobileCloudinaryUrl: string;
                smallCloudinaryUrl: string;
                thumbnailCloudinaryUrl: Types.Maybe<string>;
            };
        }>;
        faqs: Array<{
            __typename: 'FAQ';
            contentful_id: string;
            question: string;
            questionHtml: string;
            answer: string;
            answerHtml: string;
        }>;
        overview: {
            __typename: 'Overview';
            contentful_id: string;
            title: string;
            description: string;
            descriptionHtml: string;
            image: {
                __typename: 'MultimediaComponent';
                altTextOverride: string;
                cloudinaryImage: {
                    __typename: 'CloudinaryImage';
                    cloudinaryUrl: string;
                    smallCloudinaryUrl: string;
                    thumbnailCloudinaryUrl: Types.Maybe<string>;
                };
            };
        };
        primaryCta: { __typename: 'SimpleLink'; text: string; targetUrl: Types.Maybe<string> };
        inspiration: Types.Maybe<{
            __typename: 'Inspiration';
            title: string;
            subtitle: Types.Maybe<string>;
            designs: Array<{
                __typename: 'InspirationDesign';
                designer: {
                    __typename: 'ContentfulDesigner';
                    designerName: string;
                    avatarUrl: string;
                };
                image: {
                    __typename: 'MultimediaComponent';
                    altTextOverride: string;
                    cloudinaryImage: {
                        __typename: 'CloudinaryImage';
                        cloudinaryUrl: string;
                        smallCloudinaryUrl: string;
                    };
                };
            }>;
        }>;
    };
};

export const ServiceDetailsPageDataDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ServiceDetailsPageData' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'mpvId' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expertServices' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'mpvIds' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        {
                                            kind: 'Variable',
                                            name: { kind: 'Name', value: 'mpvId' },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'printProduct' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'retired' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'mpvId' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'serviceProduct' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'mpvId' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'productKey' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'pimMerchantVersion' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'price' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'currency' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'listPrice' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'taxed' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'untaxed',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'serviceDetailPage' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'mpvId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'mpvId' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'contentful_id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'merchandisingProductView' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'contentful_id' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'mpvId' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'inclusions' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'contentful_id' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'contentfulName' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'description' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'descriptionHtml' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'heroImages' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'cloudinaryImage' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'cloudinaryUrl',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'mobileCloudinaryUrl',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'smallCloudinaryUrl',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'thumbnailCloudinaryUrl',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'altTextOverride' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'contentful_id' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'faqs' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: '__typename' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'contentful_id' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'question' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'questionHtml' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'answer' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'answerHtml' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'overview' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: '__typename' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'contentful_id' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'description' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'descriptionHtml' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'image' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'altTextOverride',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: '__typename',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'cloudinaryImage',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'cloudinaryUrl',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'smallCloudinaryUrl',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'thumbnailCloudinaryUrl',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'primaryCta' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'text' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'targetUrl' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'inspiration' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'subtitle' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'designs' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'designer',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'designerName',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'avatarUrl',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'image' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'altTextOverride',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'cloudinaryImage',
                                                                        },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: {
                                                                                        kind: 'Name',
                                                                                        value: 'cloudinaryUrl',
                                                                                    },
                                                                                },
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: {
                                                                                        kind: 'Name',
                                                                                        value: 'smallCloudinaryUrl',
                                                                                    },
                                                                                },
                                                                            ],
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __useServiceDetailsPageDataQuery__
 *
 * To run a query within a React component, call `useServiceDetailsPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceDetailsPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceDetailsPageDataQuery({
 *   variables: {
 *      mpvId: // value for 'mpvId'
 *   },
 * });
 */
export function useServiceDetailsPageDataQuery(
    baseOptions: Apollo.QueryHookOptions<
        ServiceDetailsPageDataQuery,
        ServiceDetailsPageDataQueryVariables
    >
) {
    return Apollo.useQuery<ServiceDetailsPageDataQuery, ServiceDetailsPageDataQueryVariables>(
        ServiceDetailsPageDataDocument,
        baseOptions
    );
}
export function useServiceDetailsPageDataLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ServiceDetailsPageDataQuery,
        ServiceDetailsPageDataQueryVariables
    >
) {
    return Apollo.useLazyQuery<ServiceDetailsPageDataQuery, ServiceDetailsPageDataQueryVariables>(
        ServiceDetailsPageDataDocument,
        baseOptions
    );
}
export type ServiceDetailsPageDataQueryHookResult = ReturnType<
    typeof useServiceDetailsPageDataQuery
>;
export type ServiceDetailsPageDataLazyQueryHookResult = ReturnType<
    typeof useServiceDetailsPageDataLazyQuery
>;
export type ServiceDetailsPageDataQueryResult = Apollo.QueryResult<
    ServiceDetailsPageDataQuery,
    ServiceDetailsPageDataQueryVariables
>;
